import React from "react";
import AppIcon from "../AppIcon/AppIcon";
import { NavigationBarProps } from "./types";

const NavigationBar = ({ children }: NavigationBarProps) => {
  return (
    <nav className="relative z-10 px-6 py-5 fade-in">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <AppIcon />
        {children}
      </div>
    </nav>
  );
};

export default NavigationBar;
